<template>
    <v-footer app color="grey-lighten-3">
        <v-spacer />
        <div class="text-caption">
            {{ appName }} v{{ appVersion }} &copy; {{ new Date().getFullYear() }} Colours Factory Sp. z o.o.
        </div>
    </v-footer>
</template>

<script setup>
import { computed } from 'vue'

import { appConfig } from '@/config.js'

const appName = computed(() => {
    return appConfig.common.appName
})

const appVersion = computed(() => {
    return appConfig.common.appVersion
})
</script>
